export default {
    GenNonDuplicateID(randomLength = 5) {
        // eslint-disable-next-line no-undef
        return (
            Number(
                Math.random().toString().substr(3, randomLength) + Date.now()
            ).toString(36) + Date.now().toString(36).substr(3)
        );
    },
    generateActivityId(len = 16, radix = 16) {
        const uuid = this.generateUUID(len, radix)
        return 'Web-' + uuid.join('') + '-' + Date.now()
    },
    // 指定长度和基数
    generateChannelId(len = 16, radix = 16) {
        const uuid = this.generateUUID(len, radix)
        return uuid.join("") + Date.now()
    },
    generateUUID(len = 16, radix = 16) {
        const chars =
            "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
                ""
            );
        let uuid = [], i
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
        } else {
            // rfc4122, version 4 form
            let r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
            uuid[14] = "4";

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | (Math.random() * 16);
                    uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
                }
            }
        }
        return uuid;
    },
    // 获取数组重复的元素
    refrain(arr) {
        var tmp = [];
        if (Array.isArray(arr)) {
            arr
                .concat()
                .sort()
                .sort(function (a, b) {
                    if (a == b && tmp.indexOf(a) === -1) tmp.push(a);
                });
        }
        return tmp;
    }
    ,
    copyObj(data) {
        const type = this.judgeType(data);
        let obj = null;
        if (type == 'array') {
            obj = [];
            for (let i = 0; i < data.length; i++) {
                obj.push(this.copyObj(data[i]));
            }
        } else if (type == 'object') {
            obj = {}
            for (let key in data) {
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                    // if (data.hasOwnProperty(key)) {
                    obj[key] = this.copyObj(data[key]);
                }
            }
        } else {
            return data;
        }
        return obj;
    }
    ,

    judgeType(obj) {
        // tostring会返回对应不同的标签的构造函数
        const toString = Object.prototype.toString;
        const map = {
            '[object Boolean]': 'boolean',
            '[object Number]': 'number',
            '[object String]': 'string',
            '[object Function]': 'function',
            '[object Array]': 'array',
            '[object Date]': 'date',
            '[object RegExp]': 'regExp',
            '[object Undefined]': 'undefined',
            '[object Null]': 'null',
            '[object Object]': 'object',
        };
        if (obj instanceof Element) {
            return 'element';
        }
        return map[toString.call(obj)];
    }
    ,

    /**
     * 周次转星期名称
     * @param {周次} weekDay
     */
    convertWeekDayToName(weekDay = 1) {
        var weekNames = ['一', '二', '三', '四', '五', '六', '日'];
        return weekNames[weekDay - 1];
    }
    ,


    /**
     * 课堂互动活动类型转活动类型名称
     * @param {课堂互动活动类型} activityType
     */
    convertActivityTypeToName(activityType) {
        var activityObject = {
            'FAST_FEED_BACK': '快速反馈',
            'CLASS_REAL_TIME_PRACTICE': '课堂实时练习',
            'CLASS_SMART_INTERACTION': '课堂智慧互动',
            'RTC_INTERACTIVE_CLASS': '马良笔双师课堂',
        }

        return activityObject[activityType] ? activityObject[activityType] : ''

    }

}
;
